import { darkColors, lightColors } from "@certn/cascadia-tokens";
import { useTheme } from "@certn/cascadia/context/ThemeContext";

import { useBrandColors } from "../context/BrandProvider";
import { useColorScheme } from "./useColorScheme";

export function useScheme() {
  const { theme = "system" } = useTheme();
  const systemTheme = useColorScheme() || "light";
  const scheme = theme === "system" ? systemTheme : theme;
  return scheme;
}

export function useColors() {
  const brandColors = useBrandColors();
  const scheme = useScheme();

  return scheme === "light"
    ? { ...lightColors, ...brandColors }
    : { ...darkColors, ...brandColors };
}
